import { render, staticRenderFns } from "./case-excel-import.vue?vue&type=template&id=2cb8c909"
import script from "./case-excel-import.vue?vue&type=script&lang=ts"
export * from "./case-excel-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports